/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Entity from 'fierry/data/entity';
import Collection from 'fierry/data/collection';
import Lookup from 'fierry/data/lookup';

import Sector from 'solis/data/colony/sector';

import Settings from 'solis/data/settings';


export default class Colony extends Entity
{
  static children = [ 'sectors', 'zones' ];


  loadSettings (settings)
  {
    this.getSettings().load(settings.cass);
  }


  loadSector (cass)
  {
    return this.getSectors().load(cass.id, cass);
  }


  loadZone (cass)
  {
    const zone = this.getSector(cass.sector).loadZone(cass);

    this.getZones().load(zone.getAbsoluteHex(), [ cass.sector, cass.id ]);

    return zone;
  }


  unloadSector (cass)
  {
    this.getSectors().unload(cass.id);
  }


  unloadZone (cass)
  {
    const zone = this.getSector(cass.sector).getZone(cass.id);

    this.getZones().unload(zone.getAbsoluteHex());

    this.getSector(cass.sector).unloadZone(cass);
  }


  createSector (id, user)
  {
    const cass = {};

    cass.galaxy = this.cass.galaxy;
    cass.colony = this.cass.id;

    cass.id = id;
    cass.user = user;

    cass.currency = 0;
    cass.boardCount = 0;

    return this.loadSector(cass);
  }


  getSettings ()
  {
    return new Settings(this.cursor.child('settings'));
  }


  getName ()
  {
    return this.getCoreSector().cass.name;
  }


  getCoreSector ()
  {
    return this.getSector(this.cass.id);
  }


  getSector (id)
  {
    return this.getSectors().at(id);
  }


  getSectors ()
  {
    return new Collection(Sector, this.cursor.child('sectors'), this);
  }


  getZone (absoluteHex)
  {
    return this.getZones().at(absoluteHex);
  }


  getZones ()
  {
    return new Lookup(this.cursor.child('zones'), ([ sector, zone ]) =>
    {
      return this.getSector(sector).getZone(zone);
    });
  }


};
